import { useState, useEffect, useCallback } from "react";
import { VERUM_LOGO } from "@/constants";

const Navbar = () => {
  const [showNavbar, setShowNavbar] = useState(false);
  const handleScroll = useCallback(() => setShowNavbar(window.scrollY > 400), [setShowNavbar]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return (
    <nav className={`navbar ${showNavbar ? 'navbar-visible' : ''}`} data-testid="navbar">
      <div className="navbar-content">
        <div className="navbar-tagline-left" data-testid="navbar-tagline-left">
          <span className="navbar-tagline-text">True Discovery</span>
          <span className="navbar-tagline-since">Since 2018</span>
        </div>
        <img 
          src={VERUM_LOGO} 
          alt="Verum Inventa" 
          className="navbar-logo"
          data-testid="navbar-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          style={{ cursor: 'none' }}
        />
        <span className="navbar-tagline-right"></span>
      </div>
    </nav>
  );
};

export default Navbar;
